import AuthLayout from "@/ui/components/auth/AuthLayout";
import LoginForm from "@/ui/components/auth/LoginForm";

export default function Login() {
  return (
    <AuthLayout
      title="Bem-vindo de volta"
      subtitle="Entre na sua conta para continuar"
    >
      <LoginForm />
    </AuthLayout>
  );
}
